// extracted by mini-css-extract-plugin
export var button_toolbar = "toolbar_generate_palette-module--button_toolbar--116ad";
export var toolbar_wrapper = "toolbar_generate_palette-module--toolbar_wrapper--8df8f";